import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PdfOrderService } from '@services/pdf-order.service';
import { I18nModule } from '@spartacus/core';
import { DatePickerModule, DatePickerService, LaunchDialogService } from '@spartacus/storefront';

@Component({
  selector: 'app-modal-date',
  standalone: true,
  imports: [CommonModule, I18nModule, DatePickerModule],
  templateUrl: './modal-date.component.html',
  styleUrl: './modal-date.component.scss'
})
export class ModalDateComponent {
  launchDialogService = inject(LaunchDialogService);
  pdfOrderService = inject(PdfOrderService);
  customDatepickerService = inject(DatePickerService);

  form: UntypedFormGroup = this.fb.group({
    startDate: [null, Validators.required],
    endDate: [null, Validators.required]
  });

  maxDate = new Date();

  close(reason: string): void {
    this.launchDialogService.closeDialog(reason);
  }

  download(){
    this.form.markAllAsTouched();

    const startDate = this.form.get('startDate').value;
    const endDate = this.form.get('endDate').value;
    const startDateFormatted = this.getDateFormatted(startDate);
    const endDateFormatted = this.getDateFormatted(endDate);
    this.pdfOrderService.handleExcelDownload(startDateFormatted, endDateFormatted);

    this.close('download');
  }

  getDateFormatted(value: string): string {
      const placeholder = 'yyyy-mm-dd';

      const delimiter = placeholder
      .replace('yyyy', '')
      .replace('mm', '')
      .replace('dd', '')
      .substring(0, 1);

      const dateParts = value.split(delimiter);

      const y = dateParts[0];
      const m = dateParts[1];
      const d = dateParts[2];
      return `${d}/${m}/${y}`;
  }

  constructor(private fb: FormBuilder) {}
}
